import Form from "@/libs/form";

const fields = ["code"];

const rules = {
	code: "required",
};

export default Form.create(fields).validate(rules);
